<template>
	<div class="small-12 large-7 columns articleContent flex" v-if="policy">
        <div class="small-12 articlePublishedAt">
            <p>Published on {{ policy.meta.updated_at | unixToDate }}</p>
        </div>
        <div class="small-12 contentParagraph" v-for="(paragraph, index) in policy.attributes.paragraphs" :key="index">
            <div class="small-12 articleSubTitle" v-if="paragraph.title">
                <h2 class="small-12">{{paragraph.title}}</h2>
                <span class="float-left"></span>
            </div>
            <article class="float-left small-12 articleParagraph" v-if="paragraph.p">
                <p class="small-12" v-html="paragraph.p"></p>
            </article>
            <figure class="float-left small-12 articleHR flex justify-center" v-if="paragraph.hr"></figure>
        </div>
    </div>
</template>

<script>

    // Import the Filters
    import { DatesFilters } from '@/mixins/filters/DatesFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PolicyContent',

		/*
		**  Register the mixins
		*/

		mixins: [

			DatesFilters

		],

		/*
		**  Set the props
		*/

		props: {

			policy: {
                type: Object,
                default: () => null
            }

		}

	}

</script>